import { WweErrorCode } from './wwe-error-code.model';

export class WweSecurityDetailsPartialError {
	constructor(public readonly errorCodes: Map<string, WweErrorCode>, public readonly errorPortfolios: WweErrorPortfolioDetails[]) { }
}

export interface WweErrorPortfolioDetails {
	id: string;
	description: string;
}
